var _path, _path2;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgYoutube(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M20.5814 7.58168C20.4734 7.15026 20.2534 6.75497 19.9438 6.43575C19.6341 6.11652 19.2457 5.88467 18.8178 5.7636C17.2543 5.3818 13 5.3818 13 5.3818C13 5.3818 6.7458 5.3818 5.18225 5.79996C4.75432 5.92103 4.36591 6.15289 4.05626 6.47211C3.74661 6.79134 3.52669 7.18662 3.41871 7.61805C3.13255 9.20483 2.99258 10.8145 3.00055 12.4269C2.99035 14.0514 3.13033 15.6734 3.41871 17.2721C3.53775 17.6901 3.76261 18.0704 4.07153 18.3761C4.38046 18.6818 4.76302 18.9027 5.18225 19.0175C6.7458 19.4356 13 19.4356 13 19.4356C13 19.4356 17.2543 19.4356 18.8178 19.0175C19.2457 18.8964 19.6341 18.6645 19.9438 18.3453C20.2534 18.0261 20.4734 17.6308 20.5814 17.1994C20.8653 15.6245 21.0053 14.0271 20.9995 12.4269C21.0097 10.8024 20.8697 9.18042 20.5814 7.58168Z",
    stroke: "currentColor",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M9.75007 9.88345C9.75007 9.40616 9.75008 9.16752 9.84982 9.03429C9.93674 8.91819 10.0698 8.84555 10.2145 8.83521C10.3805 8.82336 10.5812 8.95241 10.9827 9.2105L14.9255 11.7452C15.2739 11.9691 15.448 12.0811 15.5082 12.2235C15.5608 12.3479 15.5608 12.4883 15.5082 12.6127C15.448 12.7551 15.2739 12.8671 14.9255 13.0911L10.9827 15.6257C10.5812 15.8838 10.3805 16.0129 10.2145 16.001C10.0698 15.9907 9.93674 15.918 9.84982 15.8019C9.75008 15.6687 9.75007 15.4301 9.75007 14.9528V9.88345Z",
    stroke: "currentColor",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgYoutube);
export default __webpack_public_path__ + "static/media/youtube.0cf2f9b727a66b028a1f41c778cf8444.svg";
export { ForwardRef as ReactComponent };